import { Divider, Stack } from '@mui/material';

import { Text, api } from 'common';

import { BlockSelectField } from '../../../ConfigFields/SelectField';
import { FilterAndSortBlockFormFields } from '../FilterAndSortFormFields';

const PatientDataStore = api.FlowDefinition.PatientDataStore;

export const SurgicalHistoriesVariant = {
  schema: PatientDataStore.SurgicalHistoriesConfigSchema,
  Config: () => {
    return (
      <Stack spacing={2}>
        <Text variant="heading5" bold>
          Surgical History Filters
        </Text>
        <BlockSelectField
          fieldName="config.surgicalHistoryFilters.status"
          label="Surgical History Status"
          helperText="Surgical History Status"
          required={false}
          options={PatientDataStore.SURGICAL_HISTORY_STATUS_OPTIONS.map((value) => ({
            label: value,
            value,
          }))}
        />
        <Divider sx={{ marginY: 2 }} />
        <FilterAndSortBlockFormFields />
      </Stack>
    );
  },
};
